import React from 'react'

import './style.css'

const Terms = () => (
  <div className="search-container terms">
    <h3>into Caerulus潛進蔚藍會員服務條款</h3>
    <p>
    into Caerulus潛進蔚藍網路平台（以下稱「本平台」）是由「蔚藍視界股份有限公司」（以下稱「本公司」）所經營之B2B2C網站，提供會員向本平台網路開店商家（以下稱「個別商家」）購買行程之服務。任何使用者使用本平台服務時，請先詳細閱讀本服務條款及其他本平台公布之相關條款，並請確實遵守；若您無法遵守本服務條款內容、或對於本服務條款內容全部或部分不同意時，提醒您請勿使用本平台服務。
    </p>
    <h4>第1條 【服務說明】</h4>
    <p>
    本平台為B2B2C網站，協助商家上架及宣傳其行程或服務，會員則可使用本平台相關功能並向個別商家購買其所提供的行程或服務。會員購買行程或服務時，並非向本公司購買，而是向個別商家購買，個別商家之名稱載明於本平台個別商家頁面。 本平台個別商家之行程或服務履行地，依據個別行程或服務之資訊頁面記載。
    </p>
    <h4>第2條 【平台會員】</h4>
    <p>
      <ul>
        <li>您同意於申請使用本平台服務時，同時加入成為本平台會員，您所填寫之個人資料將由本公司依個人資料保護法規定予以保護。您同意本公司得以電子郵件、簡訊或其他方式提供您本平台各項服務及相關優惠訊息。</li>
        <li>您所申請之帳號、密碼於本平台開通後，將得於本公司導入本平台會員登入機制之各項服務中登入使用。</li>
      </ul>
    </p>
    <h4>第3條【交易注意事項】</h4>
    <p>
      <ul>
        <li>您加入本平台會員後，即可透過本平台向在本平台上開店的個別商家，選購您所喜歡的行程或服務，亦即，您是向個別商家，而非本公司購買行程或服務。個別商家於本平台銷售頁面所載行程照片或其他說明資訊，可能因為個別行程特性有所差異，惟本公司將要求個別商家遵守消費者保護法、公平交易法等，如您所收到的行程與個別商家刊登之行程資訊不相符，您可透過本平台向個別商家申請或依法解約退貨，本公司將要求個別商家儘速處理，以保障您的權益。</li>
        <li>個別商家於本平台銷售其行程或服務，將標示於行程或服務之頁面。</li>
        <li>為維護消費者權益，如個別商家原定行程或服務內容有變更時，本平台將代替商家以電子郵件或簡訊向您通知行程或服務內容變更。若您在時程上無法配合或有其他因素致不需要該行程或服務，您得透過本平台向個別商家辦理取消訂購，本平台將立即為您辦理退款事宜。</li>
      </ul>
    </p>
    <h4>第4條【消費者權益保護】</h4>
    <p>
      <ul>
        <li>本平台中所有行程與服務，均會要求商家為個別消費會員，於服務提供期間承保意外險及醫療險，且醫療險及意外險之保額，均不得低於商家提供服務地點法規之規範。(e.g.若商家提供服務地點為於中華民國，則依水域遊憩活動管理辦法第10條之規定。)</li>
        <li>本平台將要求個別商家依消費者保護法規定保障您的權益，若個別商家有違反消費者保護法規定之情形，您可透過本平台向本公司反應，本公司將立即進行調查，並就個案要求個別商家依法處理。</li>
        <li>若您透過本平台完成之交易，決定就當次交易行程取消訂購或依法解約請求退款時，您可透過登入本平台會員帳號後，辦理取消訂購或解約退款事宜。本平台將依您原先選擇之付款方式，協助個別商家辦理信用卡刷退或退款至您轉帳付款之銀行帳戶。</li>
        <li>您透過本平台向個別商家訂購行程或服務時，請務必確認符合所需才下單購買。若經個別商家向本公司反應特定帳戶有多次無故取消訂單，或是其他顯不恰當等情形，為避免個別商家經營、作業上的困擾或損失，個別商家或本公司將得視情況拒絕交易，暫時或永久終止對您提供行程或服務銷售服務。</li>
      </ul>
    </p>
    <h4>第5條【隱私權保護】</h4>
    <p>
      <ul>
        <li>除本服務條款另有約定者外，本公司及個別商家將依個人資料保護法及本平台隱私權政策提供您有關個人資料保護及利用。</li>
        <li>本公司要求個別商家不得將會員因交易所提供之個人資料為超出該交易服務範圍之利用，以確保會員個人資料權益。若會員發現本平台個別商家，將您使用本平台所提供的個人資料運用在非特定交易之服務，而有其他行銷、廣告或不當個資利用情形，請您透過本平台客服管道與本公司聯繫，本公司將立即調查並為適當處理。</li>
      </ul>
    </p>
    <h4>第6條【平台責任限制】</h4>
    <p>
    如依法令或契約本公司須就您使用或無法使用本平台相關服務負任何賠償或違約責任時，您同意本公司所負賠償責任，以新台幣100,000元作為本公司賠償責任之上限。
    </p>
    <h4>第7條【智慧財產權的保護】</h4>
    <p>
      <ul>
        <li>本平台所使用之軟體或程式、網站上所有內容，包括但不限於著作、圖片、檔案、資訊、資料、網站架構、網站畫面的安排、網頁設計，均由本平台或其他權利人依法擁有其智慧財產權，包括但不限於商標權、專利權、著作權、營業秘密與專有技術等。任何人不得逕自使用、修改、重製、公開播送、改作、散布、發行、公開發表、進行還原工程、解編或反向組譯。若會員欲引用或轉載前述軟體、程式或網站內容，必須依法取得本平台或其他權利人的事前書面同意。尊重智慧財產權是會員應盡的義務，如有違反，會員應對本平台負損害賠償責任（包括但不限於訴訟費用及律師費用等）。</li>
        <li>在尊重他人智慧財產權之原則下，會員同意在使用本平台之服務時，不作侵害他人智慧財產權之行為。若會員有涉及侵權之情事，本平台可暫停全部或部份之服務，或逕自以取消會員帳號之方式處理。</li>
        <li>若有發現智慧財產權遭侵害之情事，請將所遭侵權之情形及聯絡方式，並附具真實陳述及擁有合法智慧財產權之聲明，以下列方式聯絡本平台電子郵件(E-mail)寄送至：<a href="mailto:info@intocaerulus.com">info@intocaerulus.com</a></li>
      </ul>
    </p>
    <h4>第8條【服務之停止、中斷】</h4>
    <p>
      本平台將依一般合理之技術及方式，維持系統及服務之正常運作。但於以下各項情況時，本平台有權可以停止、中斷提供本服務：
      <ul className="disc">
        <li>本平台網站電子通信設備進行必要之保養及施工時</li>
        <li>發生突發性之電子通信設備故障時</li>
        <li>本平台網站申請之電子通信服務被停止，無法提供服務時</li>
        <li>由於天災等不可抗力之因素或其他不可歸責於本平台致使本平台網站無法提供服務時</li>
      </ul>
    </p>
    <h4>第9條【拒絕或終止會員的使用】</h4>
    <p>
    會員同意本平台得基於維護交易安全之考量，因任何理由，包含但不限於少有使用，或違反本服務條款的明文規定及精神，終止會員的密碼、帳號（或其任何部分）或本服務（或其任何部分）之使用，或將本服務內任何「會員內容」加以移除並刪除。此外，會員同意若本服務（或其任何部分）之使用被終止，本平台對會員或任何第三人均不承擔責任。
    </p>
    <h4>第10條【服務條款變更】</h4>
    <p>
    本公司保留修改本平台服務條款之權利，並於修改後公布於本平台上，您同意自主閱讀。若該等修改涉及會員權益重大情形，將以e-mail或簡訊等方式進行通知。您於服務條款發布生效後仍繼續使用本平台相關服務，視為您同意修改內容；若您不同意修改的全部或部分內容，請您終止本平台會員之法律關係，並停止使用本平台相關服務。
    </p>
    <h4>第11條【準據法與管轄法院】</h4>
    <p>
      <ul>
        <li>本服務條款除構成您與本公司就本平台相關服務使用的完整合意外，並同時作為您與在本平台開店之個別商家間，有關透過本平台交易之契約內容。本服務條款之解釋及履行，各方同意以中華民國法律為準據法。</li>
        <li>如因本服務條款產生任何爭議，除法律另有規定者外，各方同意以台灣台北地方法院為第一審管轄法院。</li>
      </ul>
    </p>
  </div>
)
export default Terms


// WEBPACK FOOTER //
// ./src/containers/Terms/index.js